import React, { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";

import NavBar from '../navigation/NavBar';
import LoginNavBar from '../navigation/LoginNavBar';

import IsConnected from './IsConnected';
import AboutWebUI from './AboutWebUI';
import AboutThdjbr from './AboutThdjbr';

const WelcomePage = ({
  loginResult,
  processing,
  navBarVertHeight,
  navBarWidth,
  navBarHeight,
  navBarActive
}) => {
  const ref = useRef(null);

  const [ finetune, setFinetune ] = useState({
    finetuneX: window.innerWidth,
    finetuneY: window.innerHeight,
  });

  const handleResize = () => {
    setFinetune({
      finetuneX: window.innerWidth,
      finetuneY: window.innerHeight
    });
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, [window.innerWidth, window.innerHeight]);


  if (ref.current !== null && processing === 1)
    ref.current.style.cursor = 'wait';
  else if (ref.current !== null)
    ref.current.style.cursor = 'default';

  const style = navBarActive ? { background: '#0b3a53' } : { top: navBarHeight, background: '#0b3a53' };
  window.scrollTo(0, 0);

  return (
    <div ref={ref} className='times-new-roman h-100'>
      <div className='flex flex-row-reverse-l flex-column-reverse justify-end justify-start-l' style={{ minHeight: '100vh' }}>
        <div className='flex-auto-l bg-navy' style={{ width: finetune.finetuneX, height: finetune.finetuneY }}>
          <main className='pa0-l bg-navy'>
            <div className='relative' style={style}>
              <div className='flex flex-column items-center' style={{ overflowY: 'auto' }}>
              </div>
              <IsConnected />
              <div className='flex-ns ml4 mr4'>
                <div className='lh-copy mr3 mid-gray w-50-ns'>
                  <AboutWebUI />
                </div>
                <div className='lh-copy ml3 mid-gray w-50-ns mt3 mt0-ns'>
                  <AboutThdjbr />
                </div>
              </div>
            </div>
          </main>
        </div>
        { navBarActive && loginResult
          ? <div className='flex-none-l z-4 navbar-container bg-navy-nav'>
              <NavBar />
            </div>
          : !navBarActive && loginResult
          ? <div className='fixed z-4 navbar-container flex-none-l bg-navy-nav' style={{ width: navBarWidth, height: navBarHeight }}>
              <NavBar />
            </div>
          : navBarActive && !loginResult
          ? <div className='flex-none-l z-4 navbar-container bg-navy-nav'>
              <LoginNavBar />
            </div>
          : <div className='fixed z-4 navbar-container flex-none-l bg-navy-nav' style={{ width: navBarWidth, height: navBarHeight }}>
              <LoginNavBar />
            </div>
        }
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  loginResult: state.login.loginResult,
  processing: state.reserve.processing,
  navBarVertHeight: state.reserve.navBarVertHeight,
  navBarWidth: state.navigation.navBarWidth,
  navBarHeight: state.navigation.navBarHeight,
  navBarActive: state.navigation.navBarActive
});

export default connect(mapStateToProps)(WelcomePage);
